import {combineReducers} from "redux-immutable";
import state from "./stateReducer";
import dictionary from "./dictionaryReducer";
import products from "./productsReducer";
import filter from "./filterReducer";
import home from "./homeReducer";
import cart from "./cartReducer";

export default combineReducers({
    state,
    dictionary,
    products,
    filter,
    home,
    cart,
});